import { Link } from "react-router-dom";
import { COMPANY } from "@/lib/company";

export const Footer = () => (
  <footer className="border-t border-slate-800/60 bg-[#0a0a0a]" data-testid="footer">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
      <div className="md:col-span-2">
        <p className="font-heading font-extrabold text-2xl">
          Mad<span className="text-blue-500">Code</span>
        </p>
        <p className="mt-4 text-sm text-slate-400 leading-relaxed max-w-sm">
          Développeur indépendant basé à Paris, spécialisé dans la création
          d'applications web et mobiles sur mesure.
        </p>
        <p className="mt-6 font-mono text-xs text-slate-500">SIRET {COMPANY.siret}</p>
      </div>

      <div>
        <p className="font-mono text-xs tracking-[0.2em] uppercase text-blue-500 mb-5">Navigation</p>
        <ul className="space-y-3 text-sm text-slate-400">
          <li><Link to="/" className="hover:text-white transition-colors" data-testid="footer-link-accueil">Accueil</Link></li>
          <li><Link to="/services" className="hover:text-white transition-colors" data-testid="footer-link-services">Services</Link></li>
          <li><Link to="/contact" className="hover:text-white transition-colors" data-testid="footer-link-contact">Contact</Link></li>
        </ul>
      </div>

      <div>
        <p className="font-mono text-xs tracking-[0.2em] uppercase text-blue-500 mb-5">Légal</p>
        <ul className="space-y-3 text-sm text-slate-400">
          <li><Link to="/mentions-legales" className="hover:text-white transition-colors" data-testid="footer-link-mentions">Mentions légales</Link></li>
          <li><Link to="/cgv" className="hover:text-white transition-colors" data-testid="footer-link-cgv">CGV</Link></li>
          <li><Link to="/cgu" className="hover:text-white transition-colors" data-testid="footer-link-cgu">CGU</Link></li>
        </ul>
      </div>
    </div>

    <div className="border-t border-slate-800/60">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <p className="text-xs text-slate-500">
          © {new Date().getFullYear()} {COMPANY.name} — {COMPANY.owner}. Tous droits réservés.
        </p>
        <p className="font-mono text-xs text-slate-600">{COMPANY.address}</p>
      </div>
    </div>
  </footer>
);
